import React from "react";
import "./style.css";

const BackToHome = () => {
  return (
    <a href="/" title="Volver al inicio">
      <span className="floating-btn back-home-btn">
        <span className="back-home-icon" />
      </span>
    </a>
  );
};

export default BackToHome;
